var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenubar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 58.3333C16.6667 56.1232 17.5447 54.0036 19.1075 52.4408C20.6703 50.878 22.7899 50 25.0001 50H175C177.21 50 179.33 50.878 180.893 52.4408C182.455 54.0036 183.333 56.1232 183.333 58.3333C183.333 60.5435 182.455 62.6631 180.893 64.2259C179.33 65.7887 177.21 66.6667 175 66.6667H25.0001C22.7899 66.6667 20.6703 65.7887 19.1075 64.2259C17.5447 62.6631 16.6667 60.5435 16.6667 58.3333ZM16.6667 100C16.6667 97.7899 17.5447 95.6702 19.1075 94.1074C20.6703 92.5446 22.7899 91.6667 25.0001 91.6667H175C177.21 91.6667 179.33 92.5446 180.893 94.1074C182.455 95.6702 183.333 97.7899 183.333 100C183.333 102.21 182.455 104.33 180.893 105.893C179.33 107.455 177.21 108.333 175 108.333H25.0001C22.7899 108.333 20.6703 107.455 19.1075 105.893C17.5447 104.33 16.6667 102.21 16.6667 100ZM25.0001 133.333C22.7899 133.333 20.6703 134.211 19.1075 135.774C17.5447 137.337 16.6667 139.457 16.6667 141.667C16.6667 143.877 17.5447 145.996 19.1075 147.559C20.6703 149.122 22.7899 150 25.0001 150H175C177.21 150 179.33 149.122 180.893 147.559C182.455 145.996 183.333 143.877 183.333 141.667C183.333 139.457 182.455 137.337 180.893 135.774C179.33 134.211 177.21 133.333 175 133.333H25.0001Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenubar);
export default __webpack_public_path__ + "static/media/ic-menubar.77a25d837f4c5631f1afdafd733d1e65.svg";
export { ForwardRef as ReactComponent };